import { render, staticRenderFns } from "./ChatFilePreview.vue?vue&type=template&id=d51b998a&scoped=true"
import script from "./ChatFilePreview.vue?vue&type=script&lang=js"
export * from "./ChatFilePreview.vue?vue&type=script&lang=js"
import style0 from "./ChatFilePreview.vue?vue&type=style&index=0&id=d51b998a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51b998a",
  null
  
)

export default component.exports